import React, { useEffect } from "react";

import { ZoomMtg } from "@zoom/meetingsdk";
import apiKey from "../../../config/apiKey";
import { useLocation } from "react-router-dom";
import axios from "axios";

function ZoomMeetingPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const meetingNumber = queryParams.get("meetingNumber");
  const password = queryParams.get("password");
  const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
  
  var authEndpoint = `${apiKey}/api/edolutions/teacher/generate-signature`;
  var sdkKey = "vF_zXfg7SRCIBbxozW5Dg";
  // var meetingNumber = '82157403197'
  var passWord = password;
  var role = 1;
  var userName = teacher?.teacher.name;
  var userEmail = teacher?.teacher.email;
  var registrantToken = "";
  var zakToken = "";
  var leaveUrl = `${window.location.origin}/teacher/onlineTution`;

  useEffect(() => {
    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();
    function getSignature() {
      axios
        .post(
          authEndpoint,
          {
            meetingNumber: meetingNumber,
            role: role,
          },
          {
            headers: {
              Authorization: `Bearer ${teacher?.token}`,
            },
          }
        )
        .then((response) => {
          startMeeting(response.data.signature);
        })
        .catch((error) => {
          console.error(error);
        });
    }

    function startMeeting(signature) {
      document.getElementById("zmmtg-root").style.display = "block";

      ZoomMtg.init({
        leaveUrl: leaveUrl,
        patchJsMedia: true,
        leaveOnPageUnload: true,
        success: (success) => {
          // console.log(success);

          ZoomMtg.join({
            signature: signature,
            sdkKey: sdkKey,
            meetingNumber: meetingNumber,
            passWord: passWord,
            userName: userName,
            userEmail: userEmail,
            tk: registrantToken,
            zak: zakToken,
            success: (success) => {
              // console.log(success);
            },
            error: (error) => {
              console.error(error);
            },
          });
        },
        error: (error) => {
          console.error(error);
        },
      });
    }

    getSignature();
  }, [
    authEndpoint,
    leaveUrl,
    meetingNumber,
    passWord,
    registrantToken,
    role,
    sdkKey,
    teacher?.token,
    userEmail,
    userName,
    zakToken,
  ]);

  return (
    <div className="App">
      <main>
        <h1>Zoom Meeting SDK Sample React</h1>

        {/* <button onClick={getSignature}>Join Meeting</button> */}
      </main>
    </div>
  );
}

export default ZoomMeetingPage;
